import { type Dayjs } from 'src/helpers/dayjs';
import { useTranslation } from 'react-i18next';

import {
  CalendarIconWrapper,
  CalendarWeekdayPill,
  DateIcon,
  DateIconDay,
  DateIconMonth,
} from 'src/common/components/styled/CalendarIcon';
import { LanguageKeys } from 'src/common/constants/languages';

export default function CalendarIcon({ eventDate }: { eventDate: Dayjs }) {
  const {
    i18n: { resolvedLanguage },
  } = useTranslation();
  const currentLang = resolvedLanguage as LanguageKeys;
  const reversed = currentLang === LanguageKeys.hu;

  return (
    <CalendarIconWrapper reversed={reversed}>
      <CalendarWeekdayPill>{eventDate.format('dddd')}</CalendarWeekdayPill>
      <DateIcon reversed={reversed}>
        <DateIconDay>{eventDate.format('DD')}</DateIconDay>
        <DateIconMonth reversed={reversed}>{eventDate.format('MMM')}</DateIconMonth>
      </DateIcon>
    </CalendarIconWrapper>
  );
}
